"use client"

import { DirectionIcon, Typography } from "@/shared/ui/atoms"
import Link from "next/link"
import { useLocale } from "next-intl"
import { CSSProperties } from "react"
import { useHospitalOriginId } from "@/entities/hospital/model/hospital-origin-id"

export interface SubjectRatioRowProps {
  treatment: string
  displayTreatment?: string
  count: number
  percent: number
  className?: string
}

const clampPercent = (v: number) => Math.max(0, Math.min(100, v))

const SubjectRatioRow = ({ treatment, displayTreatment, count, percent, className }: SubjectRatioRowProps) => {
  const id = useHospitalOriginId()
  const locale = useLocale()
  const safePercent = clampPercent(percent)

  return (
    <div className={className}>
      <Link
        href={`/${locale}/review-detail/${id}?subject=${encodeURIComponent(treatment)}`}
        className="w-full flex items-center justify-start gap-0.5"
      >
        <Typography as="span" size={14} lineHeight={18} className="text-gray-900 font-semibold">
          {displayTreatment ?? treatment}
        </Typography>
        <Typography as="span" size={14} lineHeight={18} className="text-gray-600">
          ({count.toLocaleString("ko-KR")})
        </Typography>
        <DirectionIcon size={14} rotate={270} className="text-gray-500 -ml-0.5" />
      </Link>
      <div className="w-full flex items-center justify-between">
        <div className="dynamic-size flex-1 rounded-full bg-gray-100 overflow-hidden" style={{ "--max-width": 280, "--height": 5 } as CSSProperties}>
          <div className="h-full bg-primary-600 rounded-full" style={{ width: `${safePercent}%` }} />
        </div>
        <Typography size={16} lineHeight={20} className="text-gray-700 font-medium w-fit text-right">
          {safePercent}
          <span className="text-[14px]">%</span>
        </Typography>
      </div>
    </div>
  )
}

export default SubjectRatioRow
